import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetDiagnosisTemplateDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/DiagnosisTemplates/GetDetail?` + params, null);

export const GetDiagnosisTemplateList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/DiagnosisTemplates/GetList?` + params, null);

export const CreateDiagnosisTemplate = (data: any) =>
    POST_ENC(`${BASE_URL}/api/DiagnosisTemplates/Create`, data);

export const UpdateDiagnosisTemplate = (data: any) =>
    POST_ENC(`${BASE_URL}/api/DiagnosisTemplates/Update`, data);

export const DeleteDiagnosisTemplate = (data: any) =>
    POST_ENC(`${BASE_URL}/api/DiagnosisTemplates/Delete`, data);

export const RenameDiagnosisTemplate = (data: any) =>
    POST_ENC(`${BASE_URL}/api/DiagnosisTemplates/Rename`, data);

export const SaveAsDiagnosisTemplates = (data: any) =>
    POST_ENC(`${BASE_URL}/api/DiagnosisTemplates/SaveAs`, data);

export const SaveDiagnosisTemplateByDiagnosis = (data: any) =>
    POST_ENC(`${BASE_URL}/api/DiagnosisTemplates/SaveByDiagnosis`, data);
